import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { AppServiceHelperService } from "../../../services/app-service-helper.service";

/**
 * Report Designer Service
 */
@Injectable({
  providedIn: 'root'
})
export class ReportDesignerService {
  constructor(private httpClient: HttpClient, private appServiceHelper: AppServiceHelperService) { }

  /**
   * Get Template Without Json
   */
  public templateWithoutJson(): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', 'templates/noJson'));
  }

  /**
   * Get Single Template
   * @param templateId Template Id
   */
  public singleTemplate(templateId: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', `templates/details?oid=${templateId}`));
  }

  /**
   * Get report details
   */
  public getDetails(oid: number): Observable<any> {
    return this.httpClient.get<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', `report/details/single?oid=${oid}`));
  }

  /**
   * Update report details
   */
  public updateDetails(detailsData: any): Observable<any> {
    return this.httpClient.post<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', `report/details/single`), detailsData);
  }

  /**
   * Delete template by oid
   */
  public deleteTemplate(oid: any): Observable<any> {
    return this.httpClient.delete<any>(this.appServiceHelper.getServiceEndpoint('pollux.reportDesigner.api', `templates?oid=${oid}`));
  }
}
